import { cn } from "@/lib/utils";
import { track } from "@/lib/analytics";
import { useStrings } from "@/lib/i18n/context";
import { Play, Zap } from "lucide-react";
import Link from "next/link";
import React from "react";

interface CTAButtonProps {
  inNewTab?: boolean;
  children?: React.ReactNode;
  disabled?: boolean;
  className?: string;
  cta?: { text: string; href: string };
}

const CTAButton: React.FC<CTAButtonProps> = ({
  inNewTab = false,
  children,
  disabled = false,
  className,
  cta: customCta,
}) => {
  const s = useStrings();
  const cta = customCta ?? { text: s.cta.tryCrayo, href: "https://crayo.ai/dashboard" };
  const sharedClassName = cn(
    "flex text-base size-fit p-4 gap-2 items-center justify-center overflow-hidden leading-[normal] tracking-[normal] text-white transition duration-200 ease-in-out flex-row rounded-xl bg-[#2A66FF]",
    disabled
      ? "cursor-not-allowed md:opacity-50 md:hover:opacity-50"
      : "cursor-pointer md:hover:opacity-90",
    className,
  );

  return (
    <Link
      href={cta.href}
      onClick={() => track("cta_clicked", { cta: "section", href: cta.href })}
      className={sharedClassName}
      target={inNewTab ? "_blank" : undefined}
      rel={inNewTab ? "noopener noreferrer" : undefined}
    >
      {children ? (
        children
      ) : (
        <>
          <Zap className="h-[1em] w-auto fill-white text-white" /> {cta.text}
          <Play className="h-[.75em] w-auto fill-white text-white" />
        </>
      )}
    </Link>
  );
};

export default CTAButton;
